__turbopack_context__.v({
  "card": "oeO5ZW_card",
  "sticky": "oeO5ZW_sticky",
});
